import { queryOptions, useQuery } from '@tanstack/react-query'
import { api, unwrap } from '@/lib/api'
import type { Dashboard, DataEnvelope } from '@/types/api'

export const dashboardKeys = {
  all: ['dashboard'] as const,
  summary: () => [...dashboardKeys.all, 'summary'] as const,
}

export const dashboardQueryOptions = queryOptions({
  queryKey: dashboardKeys.summary(),
  queryFn: ({ signal }) => unwrap(api.get<DataEnvelope<Dashboard>>('/dashboard', { signal })),
  refetchInterval: 60_000,
})

export function useDashboard() {
  return useQuery(dashboardQueryOptions)
}
